import { AccountFeatures, AppContext } from '@lightspeed-invoicing/core-client/frontend'
import $ from "jquery"
import moment from "moment"
import 'popper.js'
import React, { Component } from 'react'
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import BottomPriceToggle from "../bottom-line/toggle.component"
import EventBus from "../common/EventBus.js"
import GlobalHelper from "../common/GlobalHelper.jsx"
import ActionButton from "../common/button/actionbutton.component.jsx"
import ConfirmButton from "../common/button/confirmbutton.component.jsx"
import SendEmailModal from "../common/email/sendemail.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import SideBar from "../common/layout/sidebar.component.jsx"
import AddPricingRow from "../common/pricing/addItem.component.jsx"
import ProposalPreviewModal from "../common/proposal/previewmodal.component.jsx"
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component'
import SendSmsModal from "../common/sms/SendSmsModal.tsx"
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import SendAsModal from "../invoice/components/SendAsModal"
import ReceivePaymentModal from "../invoice/receivepaymentmodal.component"
import { ORDER_STATUS_TYPE } from "../order-status/OrderStatusType"
import ProjectDetailsEditForm from "../quote/project/details.component.jsx"
import { InventoryLocationAction } from "../state/inventory/location/actions"
import OrderService from "../state/order/OrderService"
import { fetchPriceLevels } from '../state/price-level/PriceLevelActions'
import {
    setIsWorkflowLoadingAction,
    setPricingTable,
    setPricingTableGroupItems,
    setPricingTableGroups,
    setPricingTableInitialState,
    setPricingTableItems,
} from '../state/pricing/actions'
import { PricingTableSelector } from '../state/pricing/selectors'
import { TYPE_SMS_ORDER } from "../state/template/TemplateType"
import AddProducts from './AddProducts'
import OrderAnalytics from "./analytics.component.jsx"

const queryString = require('query-string')

const messages = defineMessages({
    "group_default_name": {
        id: 'invoice.edit.group.group_default_name',
        defaultMessage: 'Unnamed group',
    }
})

class OrderEdit extends Component {

    constructor(props, context) {
        super(props, context)

        let todayDate = moment().toDate()
        todayDate.setHours(0, 0, 0, 0)
        todayDate = moment(todayDate.toISOString()).format('YYYY-MM-DD')

        this.state = {
            status: '',
            customStatusId: '',
            contactId: '',
            redirect: '',
            sellerName: '',
            sellerId: '',
            quoteReference: null,
            priceListReference: null,
            location: null,
            items: [],
            groups: [],
            emails: [],
            internalNotes: [],
            templates: [],
            customFieldDefinitions: [],
            invoices: [],
            quotes: [],
            payments: [],
            order: null,
            proposal: null,
            projectObject: null,
            currency: '',
            identifierId: '',
            totalAmount: '',
            addItemModal: '',
            identifier: '',
            poNumber: '',
            exchangeRate: '',
            projectId: '',
            deletedAt: '',
            hash: '',
            orderId: this.props.match.params.orderId,
            loading: true,
            editable: true,
            editMode: false,
            contact: null,
            todayDate,
            previewLoading: false,
            depositAmount: '0',
            depositRatio: 0,
            paymentFromDraft : false,
            documentStatus: "",
            isWorkflowLoading: this.props.isWorkflowLoading,
        }
        this.deleteOrder = this.deleteOrder.bind(this)
        this.addGroup = this.addGroup.bind(this)
        this.updateContact = this.updateContact.bind(this)
        this.review = this.review.bind(this)
        this.refreshOrder = this.refreshOrder.bind(this)
        this.handleOrderRefresh = this.handleOrderRefresh.bind(this)
        this.handleEditOrder = this.handleEditOrder.bind(this)
        this.closeEditMode = this.closeEditMode.bind(this)
        this.setGlobalStateInitialValues = this.setGlobalStateInitialValues.bind(this)
        this.openEditOrderItemModal = this.openEditOrderItemModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.handleAddOrderItemModal = this.handleAddOrderItemModal.bind(this)
        this.handleAddProductLink = this.handleAddProductLink.bind(this)
        this.markAsOrdered = this.markAsOrdered.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.openSendEmail = this.openSendEmail.bind(this)
        this.sendProposal = this.sendProposal.bind(this)
        this.openSendSms = this.openSendSms.bind(this)
        this.createProposalAndOpenSms = this.createProposalAndOpenSms.bind(this)
        this.receivePayment = this.receivePayment.bind(this)
        this.handlePaymentOnDraft = this.handlePaymentOnDraft.bind(this)
        this.printPdf = this.printPdf.bind(this)
        this.hasReservationWorkflowFinished = this.hasReservationWorkflowFinished.bind(this)
    }

    componentDidMount() {
        this.props.dispatch(setPricingTableInitialState())
        this.refreshOrder()
        SideBar.activateMenu('order')
        const uri = queryString.parse(this.props.location.search)
        this.setState({
            editMode: uri.em === '1',
        })
        AppContext.getApiClient().get('/custom-field-definitions').then(res => {
            this.setState({
                customFieldDefinitions: res.data,
            })
        })

        if (this.props.location?.state?.contactId) {
            this.updateContact(this.props.location.state.contactId)
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.match && nextProps.match.params) {
            this.refreshOrder(nextProps.match.params.orderId)
        }

        if(AppContext.isInventoryEnabled()) {
            this.hasReservationWorkflowFinished()
        }
    }

    refreshOrder(value) {
        let orderId = ''
        if (value && typeof value === "string") {
            orderId = value
        }
        if (orderId && orderId !== this.state.orderId) {
            window.scrollTo(0, 0)
        }
        if (!orderId) {
            orderId = this.state.orderId
        }
        AppContext.getApiClient().get('/orders/' + orderId).then(ord => {
            if (ord.attributes && (this.state.identifier !== ord.attributes.identifier || this.state.customStatusId !== ord.attributes.customStatusId)) {
                EventBus.dispatch(EventBus.TopicRefreshCurrentBreadcrumb, {
                    path: `/orders/${orderId}/edit`
                })
            }
            if (ord.attributes && ord.attributes.quoteReferenceId) {
                AppContext.getApiClient().get('/quotes/' + ord.attributes.quoteReferenceId).then(q => {
                    this.setState({
                        quoteReference: q
                    })
                })
            }

            if (ord.attributes && ord.attributes.priceListReferenceId) {
                AppContext.getApiClient().get('/price-lists/' + ord.attributes.priceListReferenceId).then(priceList => {
                    if (!priceList.error) {
                        let payments = ord.attributes.paymentTransactionsFromOrder.map(p => {
                            if (p && p.objectType === 'price-lists') {
                                p.objectIdentifier = priceList.attributes.identifier
                            }
                            return p
                        })
                        this.setState({
                            payments: payments,
                            priceListReference: priceList,
                        })
                    }
                })
            }

            if (ord.attributes && ord.attributes.projectId) {
                AppContext.getApiClient().get('/projects/' + ord.attributes.projectId).then(p => {
                    this.setState({
                        projectObject: p,
                        internalNotes: p.attributes.internalNotes,
                    })
                })
            }

            if (ord.attributes && !['draft'].includes(ord.attributes.status) && ord.attributes.proposalHash) {
                AppContext.getApiClient().get('/proposals/' + ord.attributes.proposalHash).then(res => {
                    if (!res.error) {
                        this.loadProposal(res)
                    }
                })
            } else {
                this.loadProposal(null)
            }

            this.setState({
                loading: false,
                order: ord,
                orderId: ord.id,
                deletedAt: ord.attributes.deletedAt,
                identifierId: ord.attributes.identifierId,
                customStatusId: ord.attributes.customStatusId,
                projectId: ord.attributes.projectId,
                identifier: ord.attributes.identifier,
                status: ord.attributes.status,
                groups: ord.attributes.groups,
                contactId: ord.attributes.contactId,
                contact: ord.attributes.contact,
                totalAmount: ord.attributes.totalAmount,
                currency: ord.attributes.currency,
                location: ord.attributes.location,
                exchangeRate: ord.attributes.exchangeRate,
                poNumber: ord.attributes.poNumber,
                items: ord.attributes.items,
                totals: ord.attributes.totals,
                createdAt: ord.attributes.createdAt,
                sellerName: ord.attributes.seller.attributes.name,
                locationName: ord.attributes.location ? ord.attributes.location.attributes.name : '',
                locationId: ord.attributes.locationId,
                sellerId: ord.attributes.seller.id,
                depositAmount: ord.attributes.depositAmount,
                depositRatio: ord.attributes.depositRatio,
                documentStatus: ord.attributes.status,
                isWorkflowLoading: ord.attributes.status == ORDER_STATUS_TYPE.StatusOrdered && this.props.isWorkflowLoading,
            }, () => {
                this.setGlobalStateInitialValues()
                AppContext.getApiClient().post('/listing/search', {
                    keywords: '*',
                    objects: ['invoices', 'quotes'],
                    fields: ['identifier'],
                    pageSize: 100,
                    activePage: 1,
                    sortByField: 'createdAt',
                    sortAsc: true,
                    filters: {
                        "{oneOf}": {
                            "orderIds.keyword": [this.state.orderId],
                            "orderId": this.state.orderId
                        },
                    },
                    lightResult: true,
                }).then(res => {
                    const invoices = res.data.filter(item => item._type === 'invoices')
                    const quotes = res.data.filter(item => item._type === 'quotes')
                    let payments = this.state.order.attributes.paymentTransactionsFromOrder.map(p => {
                        if (p && p.objectType === 'price-lists' && this.state.priceListReference) {
                            p.objectIdentifier = this.state.priceListReference.attributes.identifier
                        }
                        return p
                    })
                    this.setState({
                        quotes: quotes,
                        invoices: invoices,
                        payments: payments,
                    })
                })
            })
        })
    }

    async hasReservationWorkflowFinished() {
        const startTime = Date.now()
        const endTime = startTime + 40000
        let isIntervalCleared = false

        const intervalWorkflow = setInterval(async () => {
            if(isIntervalCleared || !this.state.isWorkflowLoading) {
                return
            }
            const currentTime = Date.now()
            if (currentTime >= endTime) {
                clearInterval(intervalWorkflow)
                return
            }

            // check if reservations workflow is still running - will refresh order once is done
            const res = await OrderService.isWorkflowLoading(this.state.order.id)
            if(!res.isWorkflowLoading) {
                setTimeout(this.refreshOrder, 1500)
                isIntervalCleared = true
                clearInterval(intervalWorkflow)
                return
            } 
            
        }, 2000)
    }

    setGlobalStateInitialValues() {
        this.props.dispatch(fetchPriceLevels())
        this.props.dispatch(setPricingTable(this.state.order))
        if(this.state.order && AppContext.isInventoryEnabled()
            && this.state.order.attributes.inventoryLocation) {
            this.props.dispatch(InventoryLocationAction.setInventoryLocation(this.state.order.attributes.inventoryLocation))
        }
    }

    loadProposal(proposal) {
        if (proposal && proposal.attributes) {
            this.setState({
                proposal: proposal,
                hash: proposal.attributes.hash,
                pdfUri: proposal.attributes.variables.document.pdfUri,
                publicLink: proposal.attributes.publicLink,
            })
            AppContext.getApiClient().get('/proposals/' + proposal.id + '/emails').then(res => {
                const emails = res.data || []
                this.setState({
                    emails: emails,
                })
            })
        } else {
            this.setState({
                proposal: null,
                hash: '',
                pdfUri: '',
                publicLink: '',
            })
        }
    }

    deleteOrder(event) {
        event.preventDefault()
        AppContext.getApiClient().delete('/orders/' + this.state.orderId, {}).then(res => {
            this.refreshOrder()
        })
    }

    updateContact(contactId) {
        if (contactId) {
            AppContext.getApiClient().patch('/orders/' + this.state.orderId, {
                contactId: contactId
            }).then(res => {
                this.setState({
                    contactId: contactId
                })
                this.refreshOrder()
            })
        }
    }

    addGroup(event) {
        event.preventDefault()
        let groupId = ''
        return AppContext.getApiClient().post('/orders/' + this.state.orderId + '/groups', {
            name: this.props.intl.formatMessage(messages['group_default_name']),
            rank: this.state.groups.length
        }).then(g => {
            groupId = g.id
            return AppContext.getApiClient().get('/orders/' + this.state.orderId)
        }).then(ord => {
            this.setState({ groups: ord.attributes.groups }, () => {
                this.props.dispatch(setPricingTableGroups(this.state.groups, this.state.orderId))
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('#sortable-quote-group-' + groupId)?.offset()?.top - 100
                }, 500)
            })
        })
    }

    openEditOrderItemModal(itemId, productId) {
        this.setState({
            modal: <AddPricingRow
                object={this.state.order}
                mainObject={'orders'}
                mainObjectItem={'order-items'}
                objectId={this.state.orderId}
                objectIdentifier={this.state.identifier}
                onClose={this.handleCloseModal}
                itemId={itemId}
                productId={productId}
                currency={this.state.currency}
                exchangeRate={this.state.exchangeRate}
                onItemAdd={this.handleAddOrderItemModal}
                forceBillingMethod={'one-time'}
                location={this.state.order.attributes.location}
            />
        })
    }

    handleAddProductLink(e) {
        e.preventDefault()
        this.openEditOrderItemModal()
    }

    handleAddOrderItemModal(keepOpen) {
        this.refreshOrder()
        if (keepOpen) {
            return
        }
        this.setState({
            modal: ''
        })
    }

    handleCloseModal() {
        this.setState({
            modal: '',
            loading: false,
        })
        if(this.state.paymentFromDraft) {
            this.setState({
                paymentFromDraft: false,
                loading : true
            })
            this.sendProposal('', '', '', '', '', '', '', '', '')
        }
    }

    createProposal() {
        if (this.state.proposal) {
            return Promise.resolve(this.state.proposal)
        }
        return AppContext.getApiClient().get(`/orders/${this.state.orderId}/proposals`).then((res) => {
            const proposals = res.data
            if (proposals.length > 0) {
                return Promise.resolve(proposals[0])
            } else {
                return AppContext.getApiClient().post('/proposals', {
                    orderId: this.state.orderId,
                    contactId: this.state.contactId,
                    hash: this.state.order.attributes.proposalHash,
                })
            }
        })
    }

    review(event) {
        event.preventDefault()
        const uri = this.state.editMode ? '?em=1' : ''
        this.createProposal().then(res => {
            this.setState({
                redirect: <Redirect to={'/proposals/' + res.attributes.hash + '/preview' + uri} />
            })
        })
    }

    handleOrderRefresh(value) {
        this.refreshOrder(value)
    }

    handleEditOrder(orderId) {
        this.refreshOrder(orderId)
        this.setState({
            editMode: true,
        })
        window.scrollTo(0, 0)
    }

    closeEditMode(e) {
        e.preventDefault()
        this.refreshOrder()
        this.setState({
            editMode: false,
        })
        window.scrollTo(0, 0)
    }

    sendProposal(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail) {
        window.scrollTo(0, 0)
        this.createProposal().then(res => {
            AppContext.getApiClient().post('/proposals/' + res.attributes.hash + '/send-by-email', {
                subject: subject,
                toEmail: toEmail,
                ccEmail: ccEmail,
                content: content,
                buttonLabel: buttonLabel,
                attachments: pdfIncluded ?
                    [
                        {
                            name: res.attributes.variables.document.reference.concat(".pdf"),
                            fileLink: res.attributes.variables.document.pdfUri,
                            contentType: "application/pdf",
                        }
                    ] : [],
                fromEmail: fromEmail,
                bccEmail: bccEmail,
            }).then(res => {
                if (res.id) {
                    if (AppContext.isInventoryEnabled()) {
                        this.props.dispatch(setIsWorkflowLoadingAction(true))
                    }
                    this.refreshOrder(this.state.orderId)
                } else {
                    this.setState({ loading: false })
                }
            })
        })
    }

    markAsOrdered(e) {
        e.preventDefault()
        const totalAmountIsPositive = parseFloat(this.state.totalAmount) >= 0
        if (totalAmountIsPositive) {
            this.setState({ loading: true })
        }
        this.sendProposal('', '', '', '', '', '', '', '', '')
    }

    getCustomerEmailAddresses() {
        return GlobalHelper.formatContactEmail(this.state.contact.attributes.email, this.state.contact.attributes.name)
    }

    createProposalAndOpenSms(event) {
        this.createProposal().then(res => {
            const publicLink = res.attributes.publicLink
            this.openSendSms(event, publicLink)

        })
    }

    openSendSms(event) {
        event.preventDefault()
        const project = this.state.projectObject
        const accountId = project.attributes.accountId
        const customerPhoneNumbers = project.attributes.contact.attributes.phoneNumbers
        const countryCode = this.state.location ? this.state.location.attributes.organization.attributes.address.countryCode : ""

        this.setState({
            modal: <SendSmsModal
                phoneNumber={GlobalHelper.getCustomerNumber(customerPhoneNumbers)}
                projectId={project.id}
                contactId={this.state.contactId}
                accountId={accountId}
                templateType={TYPE_SMS_ORDER}
                countryCode={countryCode}
                onSubmit={() => this.sendProposal("", "", "", "", "", "", "", "", "")}
                onClose={this.handleCloseModal}
            />,
        })
    }

    openSendEmail(event) {
        event.preventDefault()
        this.setState({
            modal: <SendEmailModal
                onSubmit={this.sendProposal}
                onClose={this.handleCloseModal}
                toEmail={this.getCustomerEmailAddresses()}
                locationId={this.state.locationId}
                proposalType={'order'}
                templateKey={'send-order'}
            />
        })
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            previewLoading: true,
        })
        this.createProposal().then(res => {
            this.setState({
                previewLoading: false,
                modal: <ProposalPreviewModal
                    onClose={this.handleCloseModal}
                    pdfLink={res.attributes.variables.document.pdfUri}
                    hash={res.attributes.hash}
                    publicLink={res.attributes.publicLink}
                    proposalType={'order'}
                />
            })
        })
    }

    saveButtonsAreDisabled() {
        return false
    }

    receivePayment(event) {
        event.preventDefault()
        this.setState({
            modal: <ReceivePaymentModal
                onClose={this.handlePaymentOnDraft}
                depositPayableObject={this.state.order}
                project={this.state.projectObject}
                defaultAmount={parseFloat(this.state.order.attributes.depositBalance) > 0 ?
                    this.state.order.attributes.depositBalance : ''}
            />
        })
    }

    handlePaymentOnDraft(paymentType, appliedCreditMemoId) {
        if(paymentType != '') {
            this.setState({
                paymentFromDraft : true,
                modal: <SendAsModal
                onClose={this.handleCloseModal}
                sendBySMS={this.openSendSms}
                sendByEmail={this.openSendEmail}
                printPdf={this.printPdf}
                />
            })
    }
        else {
            this.handleCloseModal()
        }
    }


    printPdf(e) {
        this.createProposal().then(res => {
            this.handleCloseModal()
            const printUrl = res.attributes.printUrl
            GlobalHelper.redirectToPrintPdf(printUrl)
        })
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner className="py-2" />
        }
        let uniqueOrders = {}
        for (let i in this.state.order.attributes.items) {
            const item = this.state.order.attributes.items[i]
            if (item.attributes.externalPurchaseOrder) {
                uniqueOrders[item.attributes.externalPurchaseOrder.id] = item.attributes.externalPurchaseOrder
            }
        }
        const externalPurchaseOrders = Object.values(uniqueOrders)

        if (["ordered", "completed"].includes(this.state.status) && !this.state.editMode) {
            return <OrderAnalytics
                order={this.state.order}
                quoteReference={this.state.quoteReference}
                quotes={this.state.quotes}
                invoices={this.state.invoices}
                payments={this.state.payments}
                externalPurchaseOrders={externalPurchaseOrders}
                project={this.state.projectObject}
                proposal={this.state.proposal}
                identifierId={this.state.identifierId}
                currency={this.state.currency}
                identifier={this.state.identifier}
                orderId={this.state.orderId}
                addGroup={this.addGroup}
                onRefresh={this.handleOrderRefresh}
                onEdit={this.handleEditOrder}
                groups={this.state.groups}
                exchangeRate={this.state.exchangeRate}
                emails={this.state.emails}
                internalNotes={this.state.internalNotes}
                documentStatus={this.state.documentStatus}
            />
        }

        let pricingTableClassName = 'col-12 ui-module pt-0'
        if (this.state.exportedToLightspeed) {
            pricingTableClassName += ' border border-danger'
        }

        const actions = []

        if (["ordered", "completed"].includes(this.state.status)) {
            actions.push(<button key={actions.length} className="btn btn-outline-secondary mb-2 mr-2"
                onClick={this.closeEditMode}>
                <Icon value={"times"} className={"mr-1"} />
                <FormattedMessage
                    id="order.edit.close_edit_btn"
                    defaultMessage="Close edit mode"
                />
            </button>)
        }

        if (this.state.items.length > 0) {
            actions.push(<ActionButton key={actions.length} className="btn btn-outline-primary mb-2 mr-2"
                onClick={this.review}>
                <Icon value={"pencil-ruler"} className={"mr-1"} />
                <FormattedMessage
                    id="order.edit.edit_design_btn"
                    defaultMessage="Edit design"
                />
            </ActionButton>)

            if (this.state.status === "draft") {
                actions.push(<ActionButton
                    key={actions.length}
                    className="btn btn-outline-success mb-2 mr-2"
                    onClick={this.markAsOrdered}
                    disabled={this.saveButtonsAreDisabled()}>
                    <Icon value={"bullseye"} className={"mr-1"} />
                    <FormattedMessage
                        id="order.edit.mark_as_done_btn"
                        defaultMessage="Mark as done"
                    />
                </ActionButton>)
                actions.push(<button
                    className="btn btn-outline-success mr-2 mb-2"
                    onClick={this.receivePayment}>
                    <Icon value={"dollar-sign"} className={"mr-1"} />
                    <FormattedMessage
                        id="order.analytics.receive_payment_btn"
                        defaultMessage="Receive payment"
                    />
                </button>
                )
                actions.push(<ButtonWrapper
                    protectedClassName={"btn btn-success mb-2 mr-2"}
                    premium={false}
                    protectionRule={AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureSms)}
                    redirectToAccount={true}
                    className="btn btn-success mb-2 mr-2"
                    onClick={(event) => this.createProposalAndOpenSms(event)}
                    disabled={this.saveButtonsAreDisabled()} >
                    <Icon value={"mobile-alt"} className={"mr-1"} />
                    <FormattedMessage
                        id="invoice.edit.issue_and_send_sms_btn"
                        defaultMessage="SMS"
                    />
                </ButtonWrapper>)
                actions.push(<button
                    key={actions.length}
                    className="btn btn-success mb-2"
                    onClick={this.openSendEmail}
                    disabled={this.saveButtonsAreDisabled()}>
                    <Icon value={"envelope"} className={"mr-1"} />
                    <FormattedMessage
                        id="checkout.email_placeholder"
                        defaultMessage="Email"
                    />
                </button>)
            }

        }

        return <div>
            <div className="row mb-5">
                <div className="col-12">
                    {this.state.redirect}
                    {this.state.modal}
                    <div className="col-md-12">
                        <div className="px-3">
                            {this.state.projectObject &&
                                <ProjectDetailsEditForm
                                    order={this.state.order}
                                    proposal={this.state.proposal}
                                    project={this.state.projectObject}
                                    invoices={this.state.invoices}
                                    externalPurchaseOrders={externalPurchaseOrders}
                                    quotes={this.state.quotes}
                                    onChange={(project) => this.updateContact(project.contactId)}
                                    isEditable={true}
                                    refreshObject={this.refreshOrder}
                                />
                            }
                        </div>
                    </div>
                    <div className="row px-3">
                        <div className="col-12 d-flex justify-content-between">
                            <h4 className={'custom-lead'}>
                                <FormattedMessage
                                    id="order.edit.items.items_title"
                                    defaultMessage="Items"
                                />
                            </h4>
                            <div className="d-flex justify-content-end">
                                <BottomPriceToggle/>
                            </div>
                        </div>
                    </div>
                    <div className={'col-12'}>
                        <div className={'row'}>
                            <div className="col-12 ui-module pt-0">
                                <div className={"mb-3"}>
                                    <AddProducts
                                        projectId={this.state.projectId}
                                        groups={this.state.groups}
                                        location={this.state.location}
                                        items={this.state.items}
                                        openEditOrderItemModal={this.openEditOrderItemModal}
                                        identifierId={this.state.identifierId}
                                        currency={this.state.currency}
                                        identifier={this.state.identifier}
                                        orderId={this.state.orderId}
                                        handleAddProductLink={this.handleAddProductLink}
                                        addGroup={this.addGroup}
                                        refreshOrder={this.refreshOrder}
                                        totalClassName={'col-lg-8 col-md-12'}
                                        allowEdit={true}
                                        mainObject={'orders'}
                                        objectId={this.state.orderId}
                                        contactId={this.state.contactId}
                                        showLoyalty={false}
                                        payments={this.state.payments}
                                        depositAmount={this.state.depositAmount}
                                        depositRatio={this.state.depositRatio}
                                        tableId={this.state.order.attributes.pricingTableId}
                                        documentStatus={this.state.documentStatus}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        <div className="row justify-content-end">
                            {!this.state.deletedAt ?
                                <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                                    <div className={"d-flex"}>
                                        <div className={""}>
                                            <ConfirmButton
                                                onModalRender={(m, c) => {
                                                    this.setState({ modal: m }, c)
                                                }}
                                                onClick={this.deleteOrder}
                                                identifier={this.state.identifier}
                                                className="btn btn-outline-danger mr-2 mb-2"
                                            >
                                                <Icon value={"trash"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="order.edit.delete_btn"
                                                    defaultMessage="Delete"
                                                />
                                            </ConfirmButton>
                                            {this.state.items.length > 0 ?
                                                <ActionButton className={"btn btn-outline-primary mb-2"}
                                                    isLoading={this.state.previewLoading}
                                                    onClick={this.openPreview}>
                                                    <Icon value={"eye"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="order.edit.preview_btn"
                                                        defaultMessage="Preview"
                                                    />
                                                </ActionButton> : ''}
                                        </div>
                                    </div>
                                    <div className={""}>
                                        {actions}
                                    </div>
                                </div> : <div className="col-12">
                                    <p className="text-align-right text-warning m-0">
                                        <FormattedMessage
                                            id="order.archived_info"
                                            defaultMessage="This order is archived and can't be found in search results."
                                        />
                                    </p>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

const mapState = (state, props) => {
    return { 
        ...props,
        isWorkflowLoading: PricingTableSelector.getIsWorkflowLoading(state),
    }
}
const mapDispatch = (dispatch) => {
    return {
        setPricingTableItems: setPricingTableItems,
        setPricingTableGroups: setPricingTableGroups,
        setPricingTableInitialState: setPricingTableInitialState,
        setPricingTableGroupItems: setPricingTableGroupItems,
        fetchPriceLevels: fetchPriceLevels,
        setPricingTable: setPricingTable,
        setIsWorkflowLoadingAction: setIsWorkflowLoadingAction,
        InventoryLocationAction: InventoryLocationAction,
        dispatch: dispatch
    }
}
export default connect(mapState, mapDispatch)(injectIntl(OrderEdit))





// WEBPACK FOOTER //
// ./src/order/order.component.jsx